import { render, staticRenderFns } from "./TextareaFieldPreview.vue?vue&type=template&id=5ac89e86&scoped=true"
import script from "./TextareaFieldPreview.vue?vue&type=script&lang=js"
export * from "./TextareaFieldPreview.vue?vue&type=script&lang=js"
import style0 from "./TextareaFieldPreview.vue?vue&type=style&index=0&id=5ac89e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac89e86",
  null
  
)

export default component.exports